import OperationDialog from '../../../Financial/InvoiceDebtor/components/OperationDialog';
import { useState } from 'react';
import { Button, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import { ButtonLoading } from 'components';
import LoanServices from '../../services/Services';
import createToast from 'components/Toast/Toast';

export default function PaymentWithCreditDialog({ open, setOpen, installment, tableRef }) {
  const [loading, setLoading] = useState(false);
  const classes = useStyle();
  const paymentWithWallet = async () => {
    setLoading(true);
    try {
      await LoanServices.retryToPayInstallment(installment.id);
      createToast('موفق', 'عملیات با موفقیت انجام شد', 'success');
      tableRef?.current?.onQueryChange?.();
    } catch (error) {
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };
  return (
    <OperationDialog title="پرداخت با حساب دیجیتال" open={open} setOpen={setOpen}>
      <div className={classes.container}>
        <Alert severity="info" className={classes.alert}>
          آیا مایل به پرداخت قسط با استفاده از موجودی حساب دیجیتال خود هستید؟
        </Alert>
        <Grid
          md={12}
          xs={12}
          lg={12}
          style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px' }}
        >
          <ButtonLoading
            name="بله"
            color="primary"
            variant="contained"
            loading={loading}
            onClick={paymentWithWallet}
            className={classes.button}
          />
          <Button onClick={() => setOpen(false)} className={classes.button}>
            خیر
          </Button>
        </Grid>
      </div>
    </OperationDialog>
  );
}

const useStyle = makeStyles(() => ({
  title: { fontSize: '1.5em' },
  alert: {
    paddingTop: '.5em',
    paddingBottom: '.5em',
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    marginTop: '1em',
  },
}));
